/**
 * Generic comparison for table column sorting (strings, numbers, nulls).
 * For dates, return a number (e.g. getTime()) from the row getter.
 */
export function compareUnknown(a: unknown, b: unknown): number {
  if (a === b) return 0;
  const aEmpty = a == null || a === '';
  const bEmpty = b == null || b === '';
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;

  if (typeof a === 'number' && typeof b === 'number' && Number.isFinite(a) && Number.isFinite(b)) {
    return a - b;
  }

  const sa = String(a);
  const sb = String(b);
  const na = Number(sa);
  const nb = Number(sb);
  if (
    sa.trim() !== '' &&
    sb.trim() !== '' &&
    Number.isFinite(na) &&
    Number.isFinite(nb) &&
    !/[a-z]/i.test(sa) &&
    !/[a-z]/i.test(sb)
  ) {
    return na - nb;
  }

  return sa.localeCompare(sb, undefined, { numeric: true, sensitivity: 'base' });
}

export function sortRows<T>(
  rows: readonly T[],
  sortKey: string | null,
  sortDir: 'asc' | 'desc',
  getValue: (row: T, key: string) => unknown
): T[] {
  if (!sortKey || rows.length === 0) return [...rows];
  const mult = sortDir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => mult * compareUnknown(getValue(a, sortKey), getValue(b, sortKey)));
}
